import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import { Link } from 'react-router-dom'
import Loading from '../../../components/loading/loading'
// import { CardPropouse } from '../../../components/CardPropouse/CardPropouse'
// import './recevedPropose.scss'
import { Query } from "react-apollo"
import { ProposeCli } from '../../../queries/propose'
import * as dayjs from "dayjs";
import ActivityCard from "../../../components/activityCard/activityCard";

export default class sendProposes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            total: 0,
            pageNumber: 0,
            skip: 0,
            propostas: {},
            handle: false,
            playersListComplete: []
        }

        
    }

    render() {
        const cache = JSON.parse(sessionStorage.getItem('OITO'))
        if (cache) {
            this.playerId = cache.user.id

        } else {
            if (!this.state.showAlert) this.setState({
                showAlert: true,
                typeAlert: 'error',
                titleAlert: 'Você não está logado!',
                messageAlert: 'Entre ou cadastre-se. É gratuito!',
                onClose: () => window.location.href = '/login'
            })
            window.setTimeout(window.location.href = '/login', 2000)
        }
        return (
            <Fragment>
                <div className="col-xs-12" style={{ maxWidth: "980px"}}>
                    <Helmet>
                        <title>Oito - Solicitações enviadas</title>
                        <meta name="description" content="Encontre profissionais qualificados ou oportunidades imperdíveis de fazer dinheiro. Acompanhe suas solicitações e mantenha suas negociações ativas." />
                        <meta name="keywords" content="Cadastro, Oportunidades, Solicitações" />
                        <meta name="robots" content="index, follow" />
                        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
                        <meta name="language" content="Portuguese" />
                        <meta name="revisit-after" content="1 days" />
                    </Helmet>

                    {/* <div className='row center-xs'> */}

                        <h1 className="title-list">Solicitações enviadas</h1>

                        <section className="card-list row center-xs">
                            <Query query={ProposeCli} variables={{ id: this.playerId }}>
                                {result => {
                                    if (result.loading) return <Loading />
                                    if (result.error) return <p>{result.error.message}</p>
                                    // this.setState({ total: result.data.playerType.length })
                                    return (
                                        result.data.user.proposesFrom.length ?
                                            result.data.user.proposesFrom.map((prop, i) =>
                                                //<CardPropouse name={propose.anuncios? propose.anuncios.skills.name : propose.skill} date={propose.dateInit} status={propose.status} proposeHash={propose.id} key={i} />
                                                <ActivityCard link={prop.id} key={i} catg={prop.anuncio? prop.anuncio.skill.name : prop.skill} date={dayjs(prop.dateInitF ? prop.dateInitF : prop.dateInit).format("DD/MM/YYYY")} status={prop.status} />
                                            ) :
                                            <article className="msg-not-found"><h5>Você ainda não enviou nenhuma solicitação. <Link to="/anuncios">Procure aqui</Link> um profissional!</h5></article>
                                    )
                                }}
                            </Query>
                        </section>
                    {/* </div> */}
                </div>
            </Fragment>
        )
    }
}
